import { IApplicationState } from '../../types/redux';

export const selectDownloadAppBannerDisabled = (state: IApplicationState): boolean => state.downloadAppBannerDisabled;
